import { render, staticRenderFns } from "./OrderTableViewForm.vue?vue&type=template&id=7b948b86&"
import script from "./OrderTableViewForm.vue?vue&type=script&lang=js&"
export * from "./OrderTableViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports